import { DropZone } from './ui/DropZone';

export type UploadPhase = 'idle' | 'extracting' | 'success' | 'error';

export interface UploadDocInfo {
  name: string;
  chars: number;
}

interface ResumeUploadProps {
  phase: UploadPhase;
  message: string;
  docInfo: UploadDocInfo | null;
  onFileSelected: (file: File) => void;
  onRemoveDocument: () => void;
}

/**
 * Thin adapter kept so the analyzer's public surface is unchanged. The visual
 * and interaction design lives in the shared DropZone primitive.
 */
export function ResumeUpload({
  phase,
  message,
  docInfo,
  onFileSelected,
  onRemoveDocument,
}: ResumeUploadProps) {
  return (
    <DropZone
      phase={phase}
      message={message}
      docInfo={docInfo}
      onFileSelected={onFileSelected}
      onRemoveDocument={onRemoveDocument}
    />
  );
}
